import type { BirthDateIssue } from "./birthDateParts";

export type BirthDateCopy = {
  day: string;
  month: string;
  year: string;
  dayPlaceholder: string;
  monthPlaceholder: string;
  yearPlaceholder: string;
  hint: string;
  invalid: string;
  future: string;
  tooOld: string;
  incomplete: string;
  yearLength: string;
  confirmed: (formatted: string) => string;
};

export const BIRTH_DATE_COPY_DE: BirthDateCopy = {
  day: "Tag",
  month: "Monat",
  year: "Jahr",
  dayPlaceholder: "TT",
  monthPlaceholder: "MM",
  yearPlaceholder: "JJJJ",
  hint: "Wie im Ausweis: Tag, Monat, Jahr. Beispiel: 15 03 1948",
  invalid: "Dieses Datum gibt es nicht. Bitte prüfen Sie Tag und Monat.",
  future: "Das Geburtsdatum darf nicht in der Zukunft liegen.",
  tooOld: "Bitte geben Sie ein Jahr ab 1900 ein.",
  incomplete: "Bitte füllen Sie Tag, Monat und Jahr aus.",
  yearLength: "Bitte das Jahr vierstellig eingeben, zum Beispiel 1948.",
  confirmed: (formatted) => `Passt: ${formatted}`,
};

export const BIRTH_DATE_COPY_EN: BirthDateCopy = {
  day: "Day",
  month: "Month",
  year: "Year",
  dayPlaceholder: "DD",
  monthPlaceholder: "MM",
  yearPlaceholder: "YYYY",
  hint: "As on your ID: day, month, year. Example: 15 03 1948",
  invalid: "This date does not exist. Please check the day and month.",
  future: "The date of birth cannot be in the future.",
  tooOld: "Please enter a year from 1900 onwards.",
  incomplete: "Please enter the day, month and year.",
  yearLength: "Please enter the year with four digits, for example 1948.",
  confirmed: (formatted) => `Looks right: ${formatted}`,
};

export function birthDateIssueMessage(
  issue: BirthDateIssue | null,
  copy: BirthDateCopy,
): string | null {
  if (!issue) return null;
  return copy[issue];
}
